/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import { addSection, trash as deleteSection } from 'ui/Icons';

import IconButton from './IconButton';
import defaultTheme from './SectionSubHeader.css';

/**
 * renders a section header
 * @param {object} props - compnent
 * @returns {Node} rendered section header
 */
const SectionSubHeader = props => (
  <div className={defaultTheme.wrapper}>
    <div
      className={classnames(
        defaultTheme.sectionSubHeader,
        props.theme.sectionSubHeader,
        'p-4'
      )}
      onClick={props.onClick}
      data-value={props.value}
      data-test-id={props.testId}
    >
      {props.children}
    </div>
    {props.sectionIncreaseToggle && (
      <IconButton
        className={defaultTheme.sectionToggle}
        alt="Add"
        icon={addSection}
        isReadonly={props.isReadonly}
        noMargin
        onClick={props.sectionIncreaseToggle}
        rem={1.5}
        data-test-id={props.toggleTestId}
      />
    )}
    {props.sectionDecreaseToggle && (
      <IconButton
        className={defaultTheme.sectionToggle}
        alt="Delete"
        icon={deleteSection}
        isReadonly={props.isReadonly}
        noMargin
        onClick={props.sectionDecreaseToggle}
        rem={1.5}
        data-test-id={props.toggleTestId}
      />
    )}
  </div>
);

SectionSubHeader.propTypes = {
  children: propTypes.node.isRequired,
  onClick: propTypes.func,
  theme: propTypes.shape(),
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),
  sectionIncreaseToggle: propTypes.func,
  sectionDecreaseToggle: propTypes.func,
  isReadonly: propTypes.bool,
  testId: propTypes.string,
  toggleTestId: propTypes.string
};

SectionSubHeader.defaultProps = {
  theme: {},
  onClick: undefined,
  value: null,
  testId: 'sectionSubHeader-wrapper',
  sectionIncreaseToggle: undefined,
  sectionDecreaseToggle: undefined,
  isReadonly: false,
  toggleTestId: 'SectionSubHeader-wrapper'
};

export default SectionSubHeader;
